// components/News.js
import React, { useState } from 'react';
import './News.css';
import P1 from '../asste/images/new/p1.png';
import P2 from '../asste/images/new/p2.jpg';
import P3 from '../asste/images/new/p3.png';
import P4 from '../asste/images/new/p4.png';
import P5 from '../asste/images/new/P5.png';
const News = () => {
  const [currentPage, setCurrentPage] = useState(1);
  
  // 新闻数据
  const newsList = [
  
    {
      id: 1,
      title: "中标高校污水处理站运维服务",
      date: "2025-10-30",
      content: "天津勃昂环保科技有限公司在2025年10月获得高校污水处理站运维中标通知书。。",
      image: P5
    },
    {
      id: 2,
      title: "公司荣获污水处理运维一级资质",
      date: "2025-09-15",
      content: "天津勃昂环保科技有限公司在2025年9月获得污水处理站运维一级资质证书。",
      image: P1
    },
    {
      id: 3,
      title: "新型污水处理技术成功应用",
      date: "2025-04-10",
      content: "我司研发的新型污水处理技术在天津某工业园区成功应用，处理效率提升40%，获得客户高度评价。",
      image: P2
    },
    {
      id: 4,
      title: "参加国际环保技术博览会",
      date: "2025-03-05",
      content: "公司团队参加了在上海举办的国际环保技术博览会，展示了最新的环保解决方案，吸引了众多合作伙伴关注。",
      image: P3
    },
    {
      id: 5,
      title: "2025年新年快乐",
      date: "2025-01-26",
      content: "在这辞旧迎新之际，祝愿公司业绩飙升，再创佳绩。",
      image: P4
    },
    // {
    //   id: 5,
    //   title: "完成年度环保项目审计",
    //   date: "2025-08-20",
    //   content: "公司顺利通过了第三方机构的年度环保项目审计，所有项目均符合国家环保标准要求。",
    //   image: P1
    // },
    // {
    //   id: 6,
    //   title: "员工技能培训圆满结束",
    //   date: "2025-08-15",
    //   content: "为期一个月的员工专业技能培训圆满结束，提升了团队的技术服务能力。",
    //   image: P2
    // }
  ];

  const newsPerPage = 3; // 每页显示3个新闻
  const totalPages = Math.ceil(newsList.length / newsPerPage);
  
  // 获取当前页的新闻
  const getCurrentPageNews = () => {
    const startIndex = (currentPage - 1) * newsPerPage;
    return newsList.slice(startIndex, startIndex + newsPerPage);
  };

  // 切换页面
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // 生成页码
  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          className={`pagination-btn ${currentPage === i ? 'active' : ''}`}
          onClick={() => goToPage(i)}
          aria-label={`跳转到第 ${i} 页`}
        >
          {i}
        </button>
      );
    }
    return pages;
  };

  return (
    <section className="news" id="news">
      <div className="container">
        <h2>新闻动态</h2>
        <p className="news-intro">
          了解我们的最新动态和行业资讯
        </p>
        
        <div className="news-grid">
          {getCurrentPageNews().map((news) => (
            <article className="news-card" key={news.id}>
              <div className="news-image">
                <img 
                  src={news.image} 
                  alt={news.title}
                  onError={(e) => {
                    e.target.src = '新闻图片';
                  }}
                />
              </div>
              <div className="news-content">
                <span className="news-date">{news.date}</span>
                <h3 className="news-title">{news.title}</h3>
                <p className="news-excerpt">{news.content}</p>
              </div>
            </article>
          ))}
        </div>

        {/* 分页控件 */}
        {totalPages > 1 && (
          <div className="pagination-container">
            <button
              className="pagination-btn prev"
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label="上一页"
            >
              上一页
            </button>
            
            <div className="pagination-numbers">
              {renderPageNumbers()}
            </div>
            
            <button
              className="pagination-btn next"
              onClick={() => goToPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              aria-label="下一页"
            >
              下一页
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default News;